import { useEffect, useState } from "react";
import { AudioLines, Menu, X } from "lucide-react";

const LINKS = [
  { label: "The Host", href: "#host" },
  { label: "Guest Dimensions", href: "#guest-dimensions" },
  { label: "The Pitch", href: "#the-pitch" },
  { label: "Episode Flow", href: "#episode-flow" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-3 sm:top-4 inset-x-0 z-50 px-3 sm:px-4">
      <nav
        className={`max-w-6xl mx-auto rounded-full px-4 sm:px-7 py-2.5 sm:py-3 flex items-center justify-between transition-all duration-500 ${
          scrolled
            ? "bg-slate-900/80 backdrop-blur-2xl border border-white/10 shadow-2xl"
            : "bg-white/[0.03] backdrop-blur-xl border border-white/[0.06]"
        }`}
      >
        <a href="#top" data-testid="navbar-brand-logo" className="flex items-center gap-2 sm:gap-3 group min-w-0">
          <span className="relative w-8 h-8 sm:w-9 sm:h-9 rounded-2xl clay-badge flex items-center justify-center shrink-0">
            <AudioLines className="w-4 h-4 text-amber-400" />
            <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-amber-400 pulse-dot" />
          </span>
          <span className="font-display font-extrabold tracking-tight text-sm min-[360px]:text-base sm:text-lg whitespace-nowrap">
            My<span className="text-gold-gradient">IQ</span> Talks
          </span>
        </a>

        <div data-testid="navbar-nav-links" className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-xs font-semibold tracking-[0.15em] uppercase text-slate-400 hover:text-amber-300 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href="#request-slot"
            data-testid="navbar-cta-request-slot"
            className="tactile-btn hidden sm:inline-flex items-center rounded-full px-6 py-2.5 text-sm font-bold"
          >
            Be Our Guest
          </a>
          <button
            data-testid="navbar-mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden w-9 h-9 sm:w-10 sm:h-10 rounded-full glass-panel flex items-center justify-center text-slate-200 shrink-0"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          data-testid="navbar-mobile-drawer"
          className="lg:hidden mt-2 sm:mt-3 max-w-6xl mx-auto rounded-3xl glass-panel p-5 sm:p-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm font-semibold tracking-[0.15em] uppercase text-slate-300 hover:text-amber-300 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#request-slot"
            onClick={() => setOpen(false)}
            className="tactile-btn inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-bold"
          >
            Be Our Guest
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
